module.exports = __webpack_public_path__ + "static/media/edelgard-vonhresvelg-win.4981ad80.png";